import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { URL } from 'src/app/core/constants/urls.constant';
import { NavigationSetup } from 'src/app/core/services/navigation-items-service/navigation-setup';
import { UrlService } from 'src/app/core/services/url-service/url.service';

@Component({
  selector: 'app-not-found-page',
  standalone: true,
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotFoundPageComponent {
  router = inject(Router);
  urlService = inject(UrlService);
  previousUrl = this.urlService.previousUrl;
  isAppOrCollectionDetailNotFound = computed(() => this.isFromAppOrCollectionDetailNotFound(this.previousUrl()))

  renderData = computed(() => {
      return this.isAppOrCollectionDetailNotFound() ? {
        isDisplay404: false,
        headline: 'App or Collection not found',
        explanatoryText: 'The link you used may be outdated, or the item may have been removed. We suggest asking the person who gave you the link for an updated one.',
        actionOrientLink: {
          name: 'Alternatively go to App Finder to find your App or Collection',
          url: NavigationSetup.APP_FINDER.path
        }
      } :
      {
        isDisplay404: true,
        headline: 'Page not found',
        explanatoryText: 'It might have been moved, deleted, or the URL might be incorrect.',
        actionOrientLink: {
          name: 'NG Portal Support',
          url: URL.SUPPORT_LINK
        }
    }

  })

  isFromAppOrCollectionDetailNotFound(previousUrl: string | undefined) {
    if(!previousUrl) return false;

    const appDetailSegments = this.urlService.getUrlSegments(NavigationSetup.APP_DETAIL_PAGE.path)
    const collectionDetailSegments = this.urlService.getUrlSegments(NavigationSetup.COLLECTION_DETAIL_PAGE.path)
    const prevUrlSegments: string[] = this.urlService.getUrlSegments(previousUrl)

    return (
      this.isSamePattern(prevUrlSegments, appDetailSegments) ||
      this.isSamePattern(prevUrlSegments, collectionDetailSegments)
    );
  }

  isSamePattern(actual: string[], expected: string[]): boolean {
    return (
      actual.length === expected.length &&
      actual[0] === expected[0]
    );
  }

  navigate() {
    const { url } = this.renderData().actionOrientLink;
    this.isAppOrCollectionDetailNotFound() ? this.router.navigateByUrl(url) : window.open(url, '_blank');
  }
}
